import React, { useState, useEffect } from "react";
import api from "../../utils/api.utils";
import { useNavigate } from "react-router-dom";
import { NavbarAdmin } from "../../components/NavbarAdmin";
import { FooterAdmin } from "../../components/FooterAdmin";

import "../css/AdminHome.css";
export const AdminHome = ({ loading, setLoading, loadingGif }) => {
  const status = "cadastrada";

  const [ouvidorias, setOuvidorias] = useState([]);

  const navigate = useNavigate();

  const goToManifestacao = (ouvidoriaId) => {
    navigate(`/admin/ouvidoria/${ouvidoriaId}/`);
  };

  useEffect(() => {
    const getOuvidoriaByStatus = async () => {
      try {
        const data = await api.getOuvidoriaByStatus(status);
        setOuvidorias(data);

        setLoading(false);
      } catch (error) {
        console.log(error, "Error to get Ouvidoria!");
      }
    };
    getOuvidoriaByStatus();
  }, [loading, setLoading, status]);
  // let count = 0;
  let statusAtual = "";
  return (
    <div>
      <NavbarAdmin />
      <div className="container mt-3">
        <h5>
          <p>Seja bem-vindo!</p>
          <span>Manifestações cadastradas disponíveis.</span>
        </h5>
      </div>
      <hr />
      <div className="container">
        <div className="card-new-wrap">
          {!loading ? (
            ouvidorias?.map((ouvidoria, index) => {
              if (
                ouvidoria.status === "em-andamento" &&
                ouvidoria.etapa === "usuario"
              ) {
                statusAtual = "Aguardando resposta do usuário";
              } else {
                statusAtual =
                  ouvidoria.status[0].toUpperCase() +
                  ouvidoria.status.substring(1).replace("-", " ");
              }

              if (ouvidoria.tipo === "reclamacoes")
                ouvidoria.tipo = "reclamações";
              if (ouvidoria.tipo === "sugestoes") ouvidoria.tipo = "sugestões";

              let anoOuv = ouvidoria.createdAt.slice(0, 4);
              return (
                <div
                  key={index}
                  className="card-new clickable"
                  onClick={() => goToManifestacao(ouvidoria._id)}
                >
                  <span className="fs-5">
                    #{anoOuv}OUV{ouvidoria.protocolo_id}
                  </span>
                  <span>
                    <i className="bi bi-calendar-check"></i>
                    {new Intl.DateTimeFormat("default", {
                      timeZone: "America/Sao_Paulo",
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    }).format(new Date(ouvidoria.createdAt))}
                    h
                  </span>

                  <span>
                    <i className="bi bi-blockquote-left"></i>
                    {ouvidoria.tipo[0].toUpperCase() +
                      ouvidoria.tipo.substring(1).replace("-", " ")}
                  </span>
                  <span>
                    <i className="bi bi-person-fill"></i>
                    {ouvidoria.name || "Anônimo"}
                  </span>
                  <span>
                    <i className="bi bi-bar-chart-steps"></i>
                    {statusAtual}
                  </span>
                </div>
              );
            })
          ) : (
            <img
              style={{ width: "100px" }}
              src={loadingGif}
              alt="Loading gif"
            />
          )}
        </div>
        {ouvidorias.length < 1 && (
          <div className="alert alert-info">
            Nenhuma manifestação cadastrada!
          </div>
        )}
        {/* <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Data</th>
              <th scope="col">Protocolo</th>

              <th scope="col" className="no-mobile">
                Tipo
              </th>
              <th scope="col" className="no-mobile">
                Manifestante
              </th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              ouvidorias.length > 0 ? (
                ouvidorias?.map((ouvidoria, index) => {
                  let anoOuv = ouvidoria.createdAt.slice(0, 4);
                  count++;
                  return (
                    <tr
                      key={index}
                      className="clickable"
                      onClick={() => goToManifestacao(ouvidoria._id)}
                    >
                      <th scope="row">{count}</th>
                      <td>
                        {new Intl.DateTimeFormat("default", {
                        timeZone: "America/Sao_Paulo",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      }).format(new Date(ouvidoria.createdAt))}h
                      </td>
                      <td><strong>{anoOuv}OUV{ouvidoria.protocolo_id}</strong></td>
                      <td className="no-mobile">
                        {ouvidoria.tipo[0].toUpperCase() +
                          ouvidoria.tipo.substring(1).replace("-", " ")}
                      </td>
                      <td className="no-mobile">{ouvidoria.name || "Anônimo"}</td>
                      <td>
                        {ouvidoria.status[0].toUpperCase() +
                          ouvidoria.status.substring(1)}
                      </td>
                    </tr>
                  );
                })) : (
                <tr>
                  <td colSpan="8" className="text-center p-3">
                    <h4>Nenhuma manifestação pendente!</h4>
                  </td>
                </tr>
              )

            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  <img
                    style={{ width: "100px" }}
                    src={loadingGif}
                    alt="Loading gif"
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table> */}
      </div>
      <FooterAdmin />
    </div>
  );
};
